export default __webpack_public_path__ + "graphics/experience-768.aff5975f.jpg";